import styled from 'styled-components';

import { IMenuItem } from 'shared/types/MenuItem';
import { CustomDropdownMenuSelector } from './CustomDropdownMenuSelector';
import { NativeDropdownMenuSelector } from './NativeDropdownMenuSelector';

export interface IDropdownMenuSelectorProps {
  autoFocus?: boolean;
  className?: string;
  'data-qa': string;
  disabled?: boolean;
  displayValue?: string;
  hasFormikError?: boolean;
  isLoading?: boolean;
  label?: string;
  menuItems: Array<IMenuItem>;
  name?: string;
  notFoundMessage?: string;
  onBlur?: () => void;
  onChange?: (menuItem: IMenuItem) => void;
  onMenuItemClick: (menuItem: IMenuItem) => void;
  selection: IMenuItem;
  darkTheme?: boolean;
  showLabel?: boolean;
}

export const DropdownMenuSelector = ({
  autoFocus,
  className,
  isLoading,
  label,
  menuItems,
  notFoundMessage,
  onMenuItemClick,
  showLabel = true,
  selection,
  darkTheme,
  ...props
}: IDropdownMenuSelectorProps) => {
  return (
    <DropdownMenuSelector.Wrapper className={className}>
      {/* Custom Select with native mobile behavior for touch devices */}
      <NativeDropdownMenuSelector
        label={label}
        menuItems={menuItems}
        onMenuItemClick={onMenuItemClick}
        selection={selection}
        darkTheme={darkTheme}
        showLabel={showLabel}
        {...props}
      />
      {/* Custom Select for desktop */}
      <CustomDropdownMenuSelector
        isLoading={isLoading}
        label={label}
        autoFocus={autoFocus}
        menuItems={menuItems}
        notFoundMessage={notFoundMessage}
        onMenuItemClick={onMenuItemClick}
        selection={selection}
        darkTheme={darkTheme}
        showLabel={showLabel}
        {...props}
      />
    </DropdownMenuSelector.Wrapper>
  );
};

DropdownMenuSelector.Wrapper = styled.div`
  position: relative;
  height: 100%;
  margin-top: 16px;
`;
